export default __webpack_public_path__ + "static/media/sx.d20dd205.svg";